// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2dr3f","fileBtn":"File_fileBtn___t5eT","closeBtn":"File_closeBtn__2tr1_","fileSelected":"File_fileSelected__9pxlm","disabled":"File_disabled__20Mh9"};